<template>
  <div v-if="canViewExemptBets">
    <v-select
      v-model="selectedTypeBetCasino"
      :items="typesBetCasino"
      item-text="text"
      item-value="value"
      :label="$t('filterByLobby')"
      :menu-props="{ bottom: true, offsetY: true }"
      :prepend-icon="
        selectedTypeBetCasino === 0 ? 'mdi-ticket-account' : 'mdi-account-eye'
      "
      dense
      hide-details
      solo-inverted
      @change="setSelectTypeBetCasino"
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-select-type-casino",

  data: () => ({
    selectedTypeBetCasino: 0,
  }),

  computed: {
    typesBetCasino() {
      const typesBetCasino = [
        {
          text: this.$t("validBets"),
          value: 0,
        },
        {
          text: this.$t("exemptBets"),
          value: 1,
        },
      ];

      return typesBetCasino;
    },
    canViewExemptBets() {
      if (this.$hasExemptPlayer() === false) {
        return false;
      }

      return this.$permission("132");
    },
  },

  watch: {
    $route() {
      this.selectedTypeBetCasino = 0;
      this.$store.commit("setSelectTypeBetCasino", 0);
    },
  },

  methods: {
    setSelectTypeBetCasino(type) {
      this.$store.commit("setSelectTypeBetCasino", type);
    },
  },
};
</script>
